import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const HomeSectionLink = ({ sectionId, onClick, children, ...props }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const homePath = process.env.PUBLIC_URL + "/";
  const destination = `${homePath}#${sectionId}`;

  const scrollToSection = () => {
    document.getElementById(sectionId)?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  const handleClick = (event) => {
    onClick?.(event);
    if (event.defaultPrevented) return;

    event.preventDefault();

    if (location.pathname === homePath) {
      navigate(destination);
      requestAnimationFrame(scrollToSection);
    } else {
      navigate(destination);
    }
  };

  return (
    <Link {...props} to={destination} onClick={handleClick}>
      {children}
    </Link>
  );
};

export default HomeSectionLink;
